import React from "react";
import loadingGif from "assets/images-panel/loading.gif";
import config from "../../config";

export default function Item({ item, selected, select }) {
  const renderMedia = () => {
    if (item.image?.url) {
      return (
        // eslint-disable-next-line jsx-a11y/img-redundant-alt
        <img
          className="w-full h-full gallery-image-item rounded"
          src={
            item?.external === true
              ? item.image.url
              : `${process.env.REACT_APP_MEDIA_BASE_URL}${item.image.url}`
          }
          alt="Image"
        />
      );
    } else if (item.video?.url) {
      return (
        <video className="w-full h-full rounded" controls src={item.video.url}>
          Your browser does not support the video tag.
        </video>
      );
    } else if (item.audio?.url) {
      return (
        <audio className="w-full" controls>
          <source src={item.audio.url} />
          Your browser does not support the audio tag.
        </audio>
      );
    } else {
      return (
        <img
          className="w-full h-full gallery-image-item rounded"
          src={loadingGif}
          alt="Loading"
        />
      );
    }
  };

  const getMediaTypes = () => {
    const mediaTypes = [];
    if (item.image?.url) mediaTypes.push("تصویر");
    if (item.video?.url) mediaTypes.push("ویدیو");
    if (item.audio?.url) mediaTypes.push("صوت");

    return mediaTypes.length > 0
      ? mediaTypes.join("، ")
      : "هیچ رسانه‌ای موجود نیست";
  };

  return (
    <div
      onClick={(e) => {
        select(item);
        e.stopPropagation();
      }}
      className={`relative h-auto flex p-2 mb-2 mx-1 bg-white flex-col border hover:bg-violet-100 cursor-pointer rounded shadow-sm hover:shadow-md ${
        selected ? "bg-violet-100" : ""
      }`}
    >
      {selected && (
        <div className="absolute bg-violet-100 text-[13px] p-2.5 w-full text-center inset-x-0 top-[50px]">
          این محتوا توسط شما انتخاب شده
          <div className="flex justify-center items-center">
            <span
              className="p-1.5 bg-[#ef6666] cursor-pointer text-white rounded mt-2.5"
              onClick={(e) => {
                e.stopPropagation();
                select(null);
              }}
            >
              لغو انتخاب
            </span>
          </div>
        </div>
      )}
      <div className="gallery-item-container">
        <div className="w-full flex justify-center items-center">
          {renderMedia()}
        </div>
      </div>
      <hr className="my-2" />
      <h5 className="px-1 py-1 font-bold text-sm text-gray-500 text-center hover:text-violet-600">
        {item.translations?.fa?.title || "بدون عنوان"}
      </h5>
      <div className="text-center text-gray-400 text-xs mt-1">
        <p>
          {item.author.translations.fa.name +
            " " +
            item.author.translations.fa.lastName || "نامشخص"}
        </p>
        <p>{new Date(item.createdAt).toLocaleDateString("fa-IR")}</p>
        <p className="text-gray-600 font-medium mt-2">
          شامل: {getMediaTypes()}
        </p>
      </div>
    </div>
  );
}
